<template>
  <div class="ew-pagination" :style="rootCss">
    <v-pagination
      v-model="input"
      :length="length"
      prev-icon="mdi-menu-left"
      next-icon="mdi-menu-right"
      @input="onChange"
    />
  </div>
</template>

<script>
export default {
  props: {
    value: {
      type: Number,
      default: 1,
    },
    length: {
      type: Number,
      default: 1,
    },
    color: {
      type: String,
      default: "",
    },
  },
  data() {
    return {
      input: 0,
    };
  },
  computed: {
    rootCss() {
      return {
        "--primary-color": this.color || "inherit",
      };
    },
  },
  methods: {
    onChange(value) {
      this.$emit("input", value);
      this.$emit("change", value);
    },
  },
  mounted() {
    this.input = this.value;
  },
};
</script>

<style lang="scss">
.ew-pagination {
  width: 100%;
  max-width: 500px;
  margin: 50px auto;

  .v-pagination li {
    margin: 0;
  }

  .v-pagination__navigation,
  .v-pagination__item {
    box-shadow: none;
    background-color: #fff;
    border-color: #dfdfdf;
    border-width: 1px;
    border-style: solid;
    border-radius: 0;
    padding: 5px 8px;
    margin: 0;
  }

  .v-pagination__navigation {
    padding: 17px;
  }

  .v-application .primary,
  .v-pagination__item:hover,
  .v-pagination__item:focus,
  .v-pagination__item--active {
    background-color: var(--primary-color) !important;
    border-color: var(--primary-color) !important;
    color: #fff;
    outline: none;
  }
}
</style>
